import { APIClient } from '@frontend/api-utils';

export class NotificationTemplateJsonClient extends APIClient {
    public static readonly endpoint = '/notification-api/json/v1';

    public static async fetchNotificationTemplateJson(accountId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/templates`);
        return await this.handleBlobResponse(response);
    }

    public static async postNotificationTemplateJson(accountId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);

        const response = await this.post(`${this.endpoint}/accounts/${accountId}/templates`, formData);
        return await this.handleBlobResponse(response);
    }
}
